import { render, staticRenderFns } from "./ConsultantOpportunities.vue?vue&type=template&id=6b024cf4&scoped=true"
import script from "./ConsultantOpportunities.vue?vue&type=script&lang=js"
export * from "./ConsultantOpportunities.vue?vue&type=script&lang=js"
import style0 from "./ConsultantOpportunities.vue?vue&type=style&index=0&id=6b024cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b024cf4",
  null
  
)

export default component.exports